export interface ElJSThemeOptions {
  name: string;
  base?: string;
  variables?: ElJSThemeVariable;
}

export interface ElJSThemeVariable {
  [key: string]: string | string[] | ElJSThemeVariable;
}
